import { Badge } from "primeng/badge";

export const LANDING_PAGE_GROUPS = {
    GEO_PORTAL: 'Geo - Portal',
    FINANCE_WORKS: 'Works',
    DISASTER_MANAGEMENT: 'Disaster Management',
    DRONE_COMPLIANCE: 'Drone Compliance',
    OTHER: 'Other',
    USER_MANAGEMENT: 'User Management'
};

export const SIDE_MENU_CONSTANTS: any = {
    MENU_ITEMS: [
        {
            label: 'Home',
            icon: 'home',
            badge: '',
            link: 'landing',
            resourceName: 'Home',
            resourceTypeName: 'Home',
            group_name: '',
            iconIcon: ''
        },
        {
            label: 'Geo-Portal',
            icon: 'world',
            badge: '',
            link: 'home',
            resourceName : 'Geo-Portal',
            resourceTypeName: 'Dashboards',
            group_name: 'GEO_PORTAL',
            iconIcon: 'assets/imgs/color-icon/geo-portal.svg'
        },
         {
            label: 'Sector Zone',
            icon: 'brand-storj',
            badge: '',
            link:'sector-zone',
            resourceName : 'Sector Zone',
            resourceTypeName: 'Dashboards',
            group_name: 'GEO_PORTAL',
            iconIcon: 'assets/imgs/color-icon/SectorZone.svg'
        },
        {
            label: 'Land Acquisitions And NSP',
            icon: 'map-plus',
            badge: '',
            link:'land-acquisitions',
            resourceName : 'Land Acquisitions',
            resourceTypeName: 'Dashboards',
            group_name: 'GEO_PORTAL',
            iconIcon: 'assets/imgs/color-icon/land-acquisitions.svg'
        },
        {
            label: 'LPS Village View',
            icon: 'border-sides',
            badge: '',
            link:'lps-village',
            resourceName : 'LPS Village View',
            resourceTypeName: 'Dashboards',
            group_name: 'GEO_PORTAL',
            iconIcon: 'assets/imgs/color-icon/lps.svg'
        },
        {
            label: 'Infra Zone',
            icon: 'hierarchy',
            badge: '',
            link:'infra-zone',
            resourceName : 'Infra Zone',
            resourceTypeName: 'Dashboards',
            group_name: 'GEO_PORTAL',
            iconIcon: 'assets/imgs/color-icon/infra-zones.svg'
        },
        
        {
            label: 'Geo-Portal (Theme City)',
            icon: 'world-star',
            badge: '',
            link:'new-geoportal',
            resourceName : 'Theme City',
            resourceTypeName: 'Dashboards',
            group_name: 'GEO_PORTAL',
            iconIcon: 'assets/imgs/color-icon/geo-portal-tc.svg'
        },
         {
            label: 'Layouts',
            icon: 'layout',
            badge: '',
            link:'layout',
            resourceName : 'Layout Dashboard',
            resourceTypeName: 'Dashboards',
            group_name: 'GEO_PORTAL',
            iconIcon: 'assets/imgs/color-icon/layouts.svg'
        },
        {
            label: 'LPS Summary',
            icon: 'brand-databricks',
            badge: '',
            link:'land',
            resourceName : 'LPS Summary',
            resourceTypeName: 'Dashboards',
            group_name: 'GEO_PORTAL',
            iconIcon: 'assets/imgs/color-icon/lps-summary.svg'
        },
        // {
        //     label: 'Financial Overview',
        //     icon: 'tax',
        //     badge: '',
        //     link:'financial',
        //     resourceName : 'Financial Overview',
        //     resourceTypeName: 'Dashboards',
        //     group_name: 'FINANCE_WORKS',
        //     iconIcon: 'assets/imgs/color-icon/financial-overview.svg'
        // },
        {
            label: 'Works Module',
            icon: 'building',
            badge: '',
            link:'works',
            resourceName : 'Works Module',
            resourceTypeName: 'Dashboards',
            group_name: 'FINANCE_WORKS',
            iconIcon: 'assets/imgs/color-icon/work-module.svg'
        },
        {
            label: 'Housing Module',
            icon: 'building-cottage',
            badge: '',
            link:'housing',
            resourceName : 'Housing Module',
            resourceTypeName: 'Dashboards',
            group_name: 'FINANCE_WORKS',
            iconIcon: 'assets/imgs/color-icon/housing.svg'
        },
        {
            label: 'Estate Management',
            icon: 'building-estate',
            badge: '',
            link:'estate-management',
            resourceName : 'Estate Management',
            resourceTypeName: 'Dashboards',
            group_name: 'GEO_PORTAL',
            iconIcon: 'assets/imgs/color-icon/estate-management.svg'
        },
        {
            label: 'Drone Compliance Monitoring',
            icon: 'drone',
            badge: '',
            resourceName: 'Unauthorized Cultivation',
            resourceTypeName: 'Dashboards',
            group_name: 'DRONE_COMPLIANCE',
            items: [
                {
                    label: 'Unauthorized Cultivation',
                    icon: 'wheat-off',
                    badge: '',
                    link: 'unauthorized-cultivation',
                    resourceName: 'Unauthorized Cultivation',
                    resourceTypeName: 'Dashboards',
                    group_name: 'DRONE_COMPLIANCE',
                    iconIcon: 'assets/imgs/color-icon/unauthorized-cultivation.svg'
                },
                {
                    label: 'Unauthorized Construction',
                    icon: 'building-off',
                    badge: '',
                    link: 'unauthorized-construction',
                    resourceName: 'Unauthorized Construction',
                    resourceTypeName: 'Dashboards',
                    group_name: 'DRONE_COMPLIANCE',
                    iconIcon: 'assets/imgs/color-icon/unauthorized-construction.svg'
                },
                {
                    label: 'Green Cover Monitoring',
                    icon: 'leaf',
                    badge: '',
                    link: 'green-cover-monitoring',
                    resourceName: 'Green Cover Monitoring',
                    resourceTypeName: 'Dashboards',
                    group_name: 'DRONE_COMPLIANCE',
                    iconIcon: 'assets/imgs/color-icon/green-cover.svg'
                },
                {
                    label: 'Road Network Monitoring',
                    icon: 'road',
                    badge: '',
                    link: 'road-network-monitoring',
                    resourceName: 'Road Condition Monitoring',
                    resourceTypeName: 'Dashboards',
                    group_name: 'DRONE_COMPLIANCE',
                    iconIcon: 'assets/imgs/color-icon/road-network.svg'
                }
            ]
        },
        // {
        //     label: 'Land Acquisition & NSP Overview',
        //     icon: 'brand-unsplash',
        //     badge: '',
        //     link:'land-acquisition-nsp-overview',
        //     resourceName : 'Land Acquisition And NSP',
        //     resourceTypeName: 'Dashboards',
        //     group_name: 'GEO_PORTAL',
        //     iconIcon: 'assets/imgs/color-icon/la-nsp.svg'
        // },
        
        {
      label: 'Disaster Management',
      icon: 'alert-triangle',
    //   badge: '3',                       // <-- parent badge (string or number)
    //   resourceName: 'Unauthorized Cultivation',
    //   resourceTypeName: 'Dashboards',
      group_name: 'DISASTER_MANAGEMENT',
      items: [
        {
          label: 'Shelter Management',
          icon: 'building-hospital',
        //   badge: '1',                   // child badge
          link:'shelter-management',
          resourceName : 'Shelter Management',
          resourceTypeName: 'Dashboards',
          group_name: 'DISASTER_MANAGEMENT',
          iconIcon: 'assets/imgs/color-icon/shelter-management.svg'
        },
        {
          label: 'Heatwave Advisory',
          icon: 'temperature-sun',
        //   badge: '0',                   // or '' to hide
          link: 'heatmap',
          resourceName: 'Heatwave Advisory',
          resourceTypeName: 'Dashboards',
          group_name: 'DISASTER_MANAGEMENT',
          iconIcon: 'assets/imgs/color-icon/heatwave-advisory.svg'
        },
        {
          label: 'Lightning',
          icon: 'lightning',
        //   badge: '0',                   // or '' to hide
          link: 'lightning',
          resourceName: 'Lightning',
          resourceTypeName: 'Dashboards',
          group_name: 'DISASTER_MANAGEMENT',
          iconIcon: 'assets/imgs/color-icon/lightning.svg'
        },
        {
          label: 'Winds',
          icon: 'wind',
        //   badge: '1',
          link: 'winds',
          resourceName: 'Wind',
          resourceTypeName: 'Dashboards',
          group_name: 'DISASTER_MANAGEMENT',
          iconIcon: 'assets/imgs/color-icon/winds.svg'
        },
        {
          label: 'Rainfall',
          icon: 'cloud-rain',
        //   badge: '1',
          link: 'rainfall',
          resourceName: 'Rainfall',    
          resourceTypeName: 'Dashboards',
          group_name: 'DISASTER_MANAGEMENT',
          iconIcon: 'assets/imgs/color-icon/rainfall.svg'
        },
        {
          label: 'Flooding ',
          icon: 'ripple',
        //   badge: '',   // hide if no notifications
          link: 'flooding',
          resourceName: 'Flooding',
          resourceTypeName: 'Dashboards',
          group_name: 'DISASTER_MANAGEMENT',
          iconIcon: 'assets/imgs/color-icon/flooding.svg'
        },
        {
            label: 'Cyclone',
            icon: 'wind-off',
            // badge: '',
            link:'cyclone',
            resourceName: 'Cyclone',
           resourceTypeName: 'Dashboards',
            group_name: 'DISASTER_MANAGEMENT',
            iconIcon: 'assets/imgs/color-icon/cyclone.svg'
        },
      ]
    },
        
        //  {
        //     label: 'Facilities Dashboard',
        //     icon: 'building-cottage',
        //     badge: '',
        //     link:'housing',
        //     resourceName : 'Facilities Dashboard',
        //     resourceTypeName: 'Dashboards',
        //     group_name: 'FINANCE_WORKS',
        //     iconIcon: 'assets/imgs/color-icon/housing.svg'
        // },
        {
            label: 'Metadata Management',
            icon: 'database-import',
            badge: '',
            link:'metadata-management',
            resourceName : 'Metadata Management',
            resourceTypeName: 'Dashboards',
            group_name: 'OTHER',
            iconIcon: 'assets/imgs/color-icon/metadata.svg'
        },
        // {
        //     label: 'Data Insertion',
        //     icon: 'database-plus',
        //     badge: '',
        //     link:'data-insertion',
        //     resourceName : 'Data Insertion',
        //     resourceTypeName: 'Dashboards',
        //     group_name: 'OTHER',
        //     iconIcon: 'assets/imgs/color-icon/metadata.svg'
        // },
        {
            label: 'User Management',
            icon: 'user-cog',
            badge: '',
            resourceName : 'User Management',
            resourceTypeName: 'Application',
            group_name: 'USER_MANAGEMENT',
            items: [
                {
                    label: 'Organizations',
                    icon: 'building',
                    link: 'usermgmt/customer',
                    group_name: 'USER_MANAGEMENT',
                    iconIcon: 'assets/imgs/color-icon/organization.svg',
                    resourceName: 'Organizations',
                    resourceTypeName: 'Application'
                },
                {
                    label: 'Applications',
                    icon: 'layout-2',
                    link: 'usermgmt/applications',
                    group_name: 'USER_MANAGEMENT',
                    iconIcon: 'assets/imgs/color-icon/application.svg',
                    resourceName: 'Applications',
                    resourceTypeName: 'Application'
                },
                {
                    label: 'Roles',
                    icon: 'key',
                    link: 'usermgmt/roles',
                    group_name: 'USER_MANAGEMENT',
                    iconIcon: 'assets/imgs/color-icon/roles.svg',
                    resourceName: 'Roles',
                    resourceTypeName: 'Application'
                },
                {
                    label: 'Users',
                    icon: 'users',
                    link: 'usermgmt/users',
                    group_name: 'USER_MANAGEMENT',
                    iconIcon: 'assets/imgs/color-icon/users.svg',
                    resourceName: 'Users',
                    resourceTypeName: 'Application'
                }
            ]
        },
        {
            label: 'Network Management',
            icon: 'gizmo',
            badge: '',
            resourceName : 'Network Management',
            resourceTypeName: 'Dashboards',
            group_name: 'OTHER',
            items: [
                {
                    label: 'Drainage Network',
                    icon: 'load-balancer',
                    badge: '',
                    resourceName : 'Drainage Management System',
                    resourceTypeName: 'Dashboards',
                    group_name: 'OTHER',
                    iconIcon: ''
                },
                {
                    label: 'Road Network',
                    icon: 'road',
                    badge: '',
                    resourceName : 'Road Management System',
                    resourceTypeName: 'Dashboards',
                    group_name: 'OTHER',
                    iconIcon: ''
                },
                {
                    label: 'Water Supply Network',
                    icon: 'droplet',
                    badge: '',
                    resourceName : 'Water Supply Management System',
                    resourceTypeName: 'Dashboards',
                    group_name: 'OTHER',
                    iconIcon: ''
                },
            ]
        }
        
    ]
}